import { useRef } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'

import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { creditBalanceRefundModalContainerId } from 'const/modalContainerId'
import i18n from 'strings/i18n'
import {
  ModalHeader,
  SlideInModalPortal
} from 'syf-component-library/ui/patterns/SlideInModalPortal'
import {
  AuthenticationRedirectProps,
  handleMFEAuthenticationRedirect
} from 'helpers/authenticationRedirect'
import routes from 'const/routes'
import getMFEConfig from 'helpers/getMFEConfig'
import { CreditBalanceRefundDrawer as CreditBalanceRefundDrawerComponent } from 'cbr-mfe'
import useProfileNavigate from 'hooks/useProfileNavigate'
import { getBrandRefreshPhase } from 'helpers/getBrandRefreshPhase'

export enum ModalOptions {
  refundRequest = 'refund-request',
  success = 'success',
  error = 'error',
  inProgress = 'in-progress',
  default = 'default',
  CreditBalanceRefund = 'CreditBalanceRefund'
}

const CreditBalanceRefundDrawer = () => {
  const [{ modalId, modalTriggerId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const headerRef = useRef(null)
  const { handleProfileClick } = useProfileNavigate()
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const mfeConfig = getMFEConfig('mfe')
  const brandRefreshPhase = getBrandRefreshPhase()

  const handleCloseModal = () => {
    updateModalStatus('')
  }

  const handleAuthFlow = () => {
    const props: AuthenticationRedirectProps = {
      navigateTo: routes.HOME,
      modal: 'CreditBalanceRefund',
      scope: 'read write write:sensitive profile:read:sensitive'
    }

    handleMFEAuthenticationRedirect(props)
  }

  return (
    <SlideInModalPortal
      containerId={creditBalanceRefundModalContainerId(selectedAccount)}
      escapeModalHandler={handleCloseModal}
      id={`cbr-slide-in-modal-${selectedAccount}`}
      isOpen={modalId === 'CreditBalanceRefund'}
      modalTriggerId={modalTriggerId}
      header={
        <ModalHeader
          closeModal={handleCloseModal}
          content={i18n({ button: 'creditBalanceRefund' }) as string}
          data-test="cbr-modal-header"
          dataType="x button"
          headerRef={headerRef}
        />
      }
    >
      <CreditBalanceRefundDrawerComponent
        config={mfeConfig}
        featureFlags={{ brandRefreshPhase }}
        accountId={selectedAccount}
        backToAccountManagerHandler={handleCloseModal}
        triggerAnalyticsEvent={triggerAnalyticsEvent}
        handleProfileClick={handleProfileClick}
        authenticationRedirect={handleAuthFlow}
        handleClose={handleCloseModal}
      />
    </SlideInModalPortal>
  )
}

export default CreditBalanceRefundDrawer
